import React, { memo } from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';


type AckIconProps = {
    ackValue?: number | null; // -1 | 0 | 1 | 2 | 3 | 4 (null/undefined/0 → treated as sent)
    shouldApplyMarginRight?: boolean; //if true applies margin right, if false applies margin left
};


const AckIcon: React.FC<AckIconProps> = memo(({ ackValue, shouldApplyMarginRight = false }) => {
    // These ack icons only render for our own (fromMe) messages, and by the time
    // a message appears in the team inbox it has already been accepted into
    // WhatsApp's store — it has at least been sent. So never show the pending
    // clock (ack 0) or an empty icon (ack undefined while the slim payload / live
    // ack update is still in flight): coalesce both to "sent" (single check).
    // The error state (-1) and real delivery progress (2/3/4) are preserved.
    const normalized = (ackValue == null || ackValue === 0) ? 1 : ackValue;

    const getColor = (value: number) => {
        if (value === -1) return "red";
        if (value === 3 || value === 4) return '#53bdeb';
        return 'var(--whatsapp-text)';
    };

    const iconStyle = {
        color: getColor(normalized),
        fontSize: "0.875rem",
        marginRight: shouldApplyMarginRight ? "2px" : undefined,
    };


    const icons: Record<number, JSX.Element> = {
        [-1]: <ErrorIcon sx={iconStyle} />, // error
        0: <AccessTimeIcon sx={iconStyle} />, // pending (coalesced to 1 above)
        1: <DoneIcon sx={iconStyle} />, // sent
        2: <DoneAllIcon sx={iconStyle} />, // delivered
        3: <DoneAllIcon sx={iconStyle} />, // read
        4: <DoneAllIcon sx={iconStyle} /> // played
    };

    return <>{icons[normalized]}</>;
});

export default AckIcon;
